if (!customElements.get("custom-slider")) {
  class CustomSlider extends HTMLElement {
    constructor() {
      super();
      this.splideEl = this.querySelector(".splide");
      this.progressBar = this.querySelector(".my-slider-progress-bar");
      this.scrollbar = this.querySelector("#customScrollbar");
      this.thumb = this.querySelector("#scrollbarThumb");
      this.mountSplider();
    }

    async mountSplider() {
      if (this.splideEl) {
        try {
          this.options = await JSON.parse(this.splideEl.dataset.sliderOptions || '{}');
          const splide = new Splide(this.splideEl, this.options);

          if (this.progressBar) {
            splide.on("mounted move", () => {
              const totalSlides = splide.length;
              const index = splide.index;
              const barWidth = 100 / totalSlides;
              this.progressBar.style.width = `${barWidth}%`;
              this.progressBar.style.transform = `translateX(${index * 100}%)`;
            });
          }

          this.initProgressBar(splide);
          splide.mount();
        } catch (e) {
          console.error("Error parsing slider options:", e);
        }
      }
    }

    initProgressBar(skeletonSplide) {
      const scrollbar = this.scrollbar;
      const thumb = this.thumb;

      if (!scrollbar || !thumb) return;

      skeletonSplide.on('mounted move', () => {
        const totalSlides = skeletonSplide.length;
        const slidesPerPage = skeletonSplide.options.perPage;
        const thumbWidth = (slidesPerPage / totalSlides) * 100;
        const activeIndex = skeletonSplide.index;
        const thumbPosition = (activeIndex / (totalSlides - slidesPerPage)) * (100 - thumbWidth);

        thumb.style.width = `${thumbWidth}%`;
        thumb.style.left = `${Math.max(0, thumbPosition)}%`;
      });

      let isDragging = false;
      let startX;

      const onMouseMove = (e) => {
        if (!isDragging) return;
        const deltaX = e.clientX - startX;
        const scrollbarWidth = scrollbar.offsetWidth;
        const thumbWidth = thumb.offsetWidth;
        let left = (parseFloat(thumb.style.left || 0) * scrollbarWidth) / 100 + deltaX;
        left = Math.max(0, Math.min(scrollbarWidth - thumbWidth, left));
        thumb.style.left = `${(left / scrollbarWidth) * 100}%`;
        startX = e.clientX;
        const totalSlides = skeletonSplide.length;
        const slidesPerPage = skeletonSplide.options.perPage;
        const maxLeft = scrollbarWidth - thumbWidth;
        const percentage = left / maxLeft;
        const index = Math.round(percentage * (totalSlides - slidesPerPage));
        skeletonSplide.go(index);
      };

      const onMouseUp = () => {
        isDragging = false;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        document.body.style.cursor = '';
      };

      const onTouchMove = (e) => {
        if (!isDragging) return;
        const deltaX = e.touches[0].clientX - startX;
        const scrollbarWidth = scrollbar.offsetWidth;
        const thumbWidth = thumb.offsetWidth;
        let left = (parseFloat(thumb.style.left || 0) * scrollbarWidth) / 100 + deltaX;
        left = Math.max(0, Math.min(scrollbarWidth - thumbWidth, left));
        thumb.style.left = `${(left / scrollbarWidth) * 100}%`;
        startX = e.touches[0].clientX;
        const totalSlides = skeletonSplide.length;
        const slidesPerPage = skeletonSplide.options.perPage;
        const maxLeft = scrollbarWidth - thumbWidth;
        const percentage = left / maxLeft;
        const index = Math.round(percentage * (totalSlides - slidesPerPage));
        skeletonSplide.go(index);
      };

      const onTouchEnd = () => {
        isDragging = false;
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
      };

      thumb.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.clientX;
        e.preventDefault();
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        document.body.style.cursor = 'grabbing';
      });

      thumb.addEventListener('touchstart', (e) => {
        isDragging = true;
        startX = e.touches[0].clientX;
        e.preventDefault();
        document.addEventListener('touchmove', onTouchMove);
        document.addEventListener('touchend', onTouchEnd);
      });
    }
  }

  customElements.define("custom-slider", CustomSlider);
}